import { useState } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import DefaultItemRenderer from './Option';
import { ACTIVITIES } from 'types';
import { useAppSelector } from 'store/hooks';
import { selectCallouts } from 'store/slices/companySetting';

const MultipleSelect = ({ value, setValue }: { value: Array<any>; setValue: (value: any) => void }) => {
    const callouts = useAppSelector(selectCallouts);

    const options = [
        { value: ACTIVITIES.dds, label: callouts[ACTIVITIES.dds] },
        { value: ACTIVITIES.uniqueCalls, label: callouts[ACTIVITIES.uniqueCalls] },
        { value: ACTIVITIES.earlyHangUps, label: callouts[ACTIVITIES.earlyHangUps] },
        { value: ACTIVITIES.offers, label: callouts[ACTIVITIES.offers] },
        { value: ACTIVITIES.dq, label: callouts[ACTIVITIES.dq] },
        { value: ACTIVITIES.sets, label: callouts[ACTIVITIES.sets] },
        { value: ACTIVITIES.triage, label: callouts[ACTIVITIES.triage] },
    ];

    return (
        <MultiSelect
            className="multiple-select"
            options={options}
            value={value}
            onChange={setValue}
            labelledBy="Select"
            disableSearch
            hasSelectAll={false}
            ItemRenderer={DefaultItemRenderer}
            overrideStrings={{
                selectSomeItems: 'Additional metrics',
            }}
        />
    );
};

export default MultipleSelect;
